import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    opacity: 0;
    transition: .3s;

    .section-selector-wrapper {
        margin: 0 18px auto;
        border: 1px solid rgba(151, 151, 151, 1);
        border-radius: 22px;
        text-transform: uppercase;
    }

    .section-selector { text-align: center; }

    .section-selected {
        position: relative;
        display: inline-block;
        width: auto;
        line-height: 43px;
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(35, 31, 32, 1);
        text-align: center;
        letter-spacing: 0.01em;
    }
    .section-selected:after {
        position: absolute;
        top: 46%; right: -21px;
        display: inline-block;
        content: '';
        width: 5px; height: 5px;
        border: 1px solid rgba(158, 163, 180, 1);
        border-top-width: 0;
        border-left-width: 0;
        transform: translateY(-50%) rotate(45deg);
        transition: .3s;
    }
    .selecting .section-selected:after { transform: translateY(0%) rotate(225deg); }

    .section-options {
        position: absolute;
        top: -100%; right: 20%;
        height: 0;
        border: 1px solid #eee;
        padding: 0 28px;
        background-color: rgba(255, 255, 255, 1);
        opacity: 0;
        overflow: hidden;
        z-index: 1;
        box-shadow: 0 6px 10px 0 rgba(200, 200, 200, 0.1);
        border-radius: 5px;
    }
    .selecting .section-options {
        top: 100%; right: 0;
        height: auto;
        text-align: center;
        opacity: 1;
        transition: .3s;
    }

    .section-options .options { position: relative; line-height: 62px;}
    .section-options .options:not(:last-child):after {
        position: absolute;
        bottom: 0;
        display: block;
        content: '';
        width: 100%; height: 1px;
        background-color: #ddd;
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/Selects/Wrapper.js